<template>
    <article class="card">
        <a :href="url" class="card__link">
            <div :href="url" :style="{ 'background-image': `url(${image})` }" class="card__image">
                <span class="card__image-alt" v-html="imageAlt"></span>
            </div>

            <div class="card__text-container">
                <header>
                    <category-pill :name="category"
                                   :color="color"
                                   class="card__category"
                    />
                    <div class="card__date" v-text="date"></div>
                </header>

                <main>
                    <div class="card__title" v-html="title"></div>
                    <div class="card__excerpt" v-html="excerpt"></div>
                </main>
            </div>
        </a>
    </article>
</template>

<script>
    import CategoryPill from '@/components/CategoryPill';

    export default {
        name: 'Card',

        components: { CategoryPill },

        props: {
            image:    { type: String, required: true },
            imageAlt: { type: String, required: true },
            category: { type: String, required: true },
            date:     { type: String, required: true },
            title:    { type: String, required: true },
            excerpt:  { type: String, required: true },
            url:      { type: String, required: true },
            color:    { type: String, required: true },
        },
    };
</script>

<style lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .card {
        display:       flex;

        // Fix for IE 11
        flex:          0 0 auto;
        width:         100%;

        margin-bottom: 3rem;

        &__link {
            flex:            1 1 auto;

            border:          0.1rem solid $gray-300;
            background:      $white;
            transition:      all 150ms ease-in-out;

            color:           inherit !important;
            text-decoration: none !important;

            @media screen and (min-width: map_get($grid-breakpoints, 'lg')) {
                &:hover,
                &:focus {
                    transform:  scale(1.025);
                    box-shadow: 0 0 3rem rgba(0, 0, 0, 0.25);
                }
            }
        }

        &__image {
            flex:                none;

            padding-top:         (203px * 100% / 358px);

            background-position: center;
            background-size:     cover;
        }

        &__image-alt {
            @include sr-only;
        }

        &__text-container {
            min-height: 34.5rem;

            padding:    2.5rem 3rem;
        }

        &__category {
            margin-bottom: 0.8rem;
        }

        &__date {
            margin-bottom: 0.5rem;

            font-size:     1.4rem;
        }

        &__title {
            @extend %font-OpenSans-bold;

            margin-bottom: 1rem;

            font-size:     1.8rem;
            line-height:   (24/18);
        }

        &__excerpt {
            font-size:   1.4rem;
            line-height: (22/14);
        }
    }
</style>
